import { DefaultButton } from "@fluentui/react";
import { Route, Routes } from "react-router-dom";

import { history } from "../App/history";
import Analytics from "../Components/Admin/Analytics";
import Calendar from "../Components/Calendar";
import DeliveryPaper from "../Components/DeliveryPaper";
import FormList from "../Components/Forms/List";
import FormNew from "../Components/Forms/New";
import FormSearch from "../Components/Forms/Search";
import InvoiceFromDispatch from "../Components/Invoices/FromDispatch";
import InvoiceList from "../Components/Invoices/List";
import InvoiceNew from "../Components/Invoices/New";
import InvoiceSettings from "../Components/Invoices/Settings";
import Inventory from "../Components/Tracking/Inventory";
import ProductList from "../Components/Tracking/ProductList";
import Revenue from "../Components/Tracking/Revenue";
import InventoryNew from "../Components/Shortcuts/Inventory";
import IdasShortcut from "../Components/Shortcuts/IdasPage";
import { Emaar } from "../Components/Emaar";

export default () => (
  <Routes>
    <Route path="/forms">
      <Route path="new" element={<FormNew />} />
      <Route path="list" element={<FormList />} />
      <Route path="search" element={<FormSearch />} />
    </Route>
    <Route path="/invoices">
      <Route path="new" element={<InvoiceNew />} />
      <Route path="from-dispatch/:formId" element={<InvoiceFromDispatch />} />
      <Route path="list" element={<InvoiceList />} />
      <Route path="settings" element={<InvoiceSettings />} />
    </Route>
    <Route path="/tracking">
      <Route path="inventory" element={<Inventory />} />
      <Route path="product-list" element={<ProductList />} />
      <Route path="revenue" element={<Revenue />} />
    </Route>
    <Route path="calendar" element={<Calendar />} />
    <Route path="delivery-paper" element={<DeliveryPaper />} />
    <Route path="/admin">
      <Route path="analytics" element={<Analytics />} />
    </Route>

    <Route path="/emaar" element={<Emaar />} />
    <Route path="/inventory" element={<InventoryNew />} />
    <Route path="/idas-shortcut" element={<IdasShortcut />} />
    <Route path="/" element={<Homepage />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);
const Homepage = () => (
  <div
    style={{
      transform: "translateX(-50%)",
      marginLeft: "50%",
      width: "400px",
      textAlign: "center",
    }}
  >
    <h1>İyi günler</h1>
    <DefaultButton
      text="Yeni Form"
      iconProps={{ iconName: "Add" }}
      onClick={() => history.push("/forms/new")}
    />
  </div>
);

const NotFoundPage = () => (
  <div
    style={{
      transform: "translateX(-50%)",
      marginLeft: "50%",
      width: "400px",
      textAlign: "center",
    }}
  >
    <h1>Sayfa Bulunamadı</h1>
    <DefaultButton
      text="Anasayfa"
      iconProps={{ iconName: "Home" }}
      onClick={() => history.push("/")}
    />
  </div>
);
